module.exports = __webpack_public_path__ + "static/milestone-bg-0f69d901457c2387f97d517513455a2b.png";